export default "__VITE_ASSET__BUVBm5RU__"